











import Vue from 'vue';
import StepNumber from '@/components/common/StepNumber.vue';

export default Vue.extend({
  name: 'ProgressBar',
  components: {
    StepNumber,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/ProgressBar.vue